import { useContext } from "react";
import { Tooltip, Stack, Group, ThemeIcon, Text } from "@mantine/core";
import { IconFolder, IconFolderOpen } from "@tabler/icons-react";
import { PIPE_TYPE_LABELS } from "../utils/constants";
import { FoldersContext } from "../contexts/FoldersContext";

export default function FolderTooltip({
  folder,
  showPath,
  children,
  ...tooltipProps
}) {
  const { label, standardName = "", pipeType = "", createdDate } = folder;
  const { folderIdMap } = useContext(FoldersContext);
  const tooltipColor =
    "light-dark(var(--mantine-color-gray-9), var(--mantine-color-gray-0))";

  const formattedDate = createdDate
    ? new Date(createdDate).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  const content = (
    <Stack py={6} px={2} gap={4}>
      <Group gap="xs" align="center">
        <ThemeIcon variant="light" size="xl" radius="sm">
          <IconFolder size={18} />
        </ThemeIcon>
        <Stack gap={0}>
          <Text
            size="sm"
            fw={600}
            styles={{
              root: {
                color: tooltipColor,
              },
            }}
          >
            {label}
          </Text>
          <Text size="xs" c="dimmed">
            {standardName}
            {standardName && pipeType && " • "}
            {PIPE_TYPE_LABELS[pipeType]}
            {(standardName || pipeType) && formattedDate && " • "}
            {formattedDate}
          </Text>
        </Stack>
      </Group>
      {showPath && (
        <Stack mt="xs" gap={2}>
          {folder.path && folder.path.length > 0 ? (
            folder.path.map((pathItem, index) => (
              <Group key={index} gap="xs" px={index * 12} align="center">
                <IconFolderOpen
                  size={18}
                  style={{
                    verticalAlign: "middle",
                    color: tooltipColor,
                  }}
                />
                <Text style={{ color: tooltipColor }} size="xs">
                  {folderIdMap[pathItem]}
                </Text>
              </Group>
            ))
          ) : (
            <Text size="xs" c="dimmed">
              No path available
            </Text>
          )}
        </Stack>
      )}
    </Stack>
  );

  return (
    <Tooltip
      multiline
      position="right"
      keepMounted={false}
      openDelay={500}
      offset={20}
      label={content}
      styles={{
        tooltip: {
          border:
            "1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-5))",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
          backgroundColor: "light-dark(white, var(--mantine-color-dark-9))",
        },
      }}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
}
